import socialConnect from 'fed-resources/resources/social-connect';

export async function toggleDisqusClaim(context, { spotId }, done) {
  try {
    await socialConnect.toggleDisqusClaim(spotId);
    context.dispatch('TOGGLE_DISQUS_CLAIM', { spotId });
    done();
  } catch (reason) {
    context.dispatch('TOGGLE_DISQUS_CLAIM', { error: reason });
    done();
  }
}
